export const ru = {
    knowledgeBaseTitle: 'База знаний',
    contactUs: 'Написать нам',
    searchPlaceholder: 'Какой вопрос вас интересует?',
    files: 'Файлы',
    mb: 'МБ',
    kb: 'КБ',
    writeToUs: 'Написать нам',
    namePlaceholder: 'Как вас зовут?',
    emailPlaceholder: 'Электронная почта',
    messagePlaceholder: 'Текст сообщения',
    selectFiles: 'Выберите файлы',
    orDropFiles: ' или перетащите',
    maxFileSizeError: 'Допустимый объем прикрепляемых файлов - {maxSize} MB',
    send: 'Отправить',
    continue: 'Продолжить',
    back: 'Назад',
    operator: 'Оператор',
    successTitle: 'Ваше сообщение отправлено!',
    successText: 'Мы ответим вам в ближайшее время.',
    onlineStatus: 'Онлайн',
    messageDeleted: 'Сообщение удалено',
    replay: 'Ответить',
    delete: 'Удалить',
    chatInputPlaceholder: 'Написать сообщение...',
    deleteModalTitle: 'Удаление',
    deleteModalText: 'Вы уверены, что хотите удалить это сообщение?',
    cancel: 'Отмена',
    sizeExceededModalTitle: 'Слишком большой файл',
    sizeExceededModalText: `Допустимый объем файлов {maxSize} MB`,
    ok: 'ОК',
    file: 'Файл',
    footer: 'Мы используем ',
    personalDataPolicyLabel: 'Нажимая на кнопку, вы соглашаетесь на',
    personalDataPolicyLink: ' обработку персональных данных',
};
